import type { Tier } from "../../api/contracts";
import { formatMinutes } from "../lib/format";
import { tierCoverage, tierText } from "../lib/rules";
import { cx } from "./ui";

const SCALE_MAX = 240; // minutes of open time drawn; the open-ended tier fills the rest
// Figma: no block in grey, each larger block a deeper pink, all with the same plum ink.
const TIER_TONE = ["bg-hs-tier-1", "bg-hs-tier-2", "bg-hs-tier-3", "bg-hs-primary/60"];

/** Horizontal band of open time at the start or end: no block, each tier, and any uncovered gap (drawn in danger). */
export function CoverageBar({ tiers }: { tiers: Tier[] }) {
  const segs = tierCoverage(tiers);
  return (
    <div>
      <p className="mb-2 text-base font-semibold text-hs-text">Block added, by open time at the start or end of a shift</p>
      <div className="flex h-[55px] w-full divide-x-2 divide-white overflow-hidden rounded-2xl" role="img" aria-label="Which BTB block each amount of open time at the start or end gets">
        {segs.map((s, i) => {
          const end = s.to === null ? SCALE_MAX : Math.min(s.to + 1, SCALE_MAX);
          const width = Math.max(0, end - Math.min(s.from, SCALE_MAX)) / SCALE_MAX * 100;
          if (width <= 0) return null;
          const tone = s.kind === "tier" ? `${TIER_TONE[(s.tierIndex ?? 0) % TIER_TONE.length]} text-hs-tier-ink` : s.kind === "gap" ? "bg-hs-danger-soft text-hs-danger" : "bg-hs-chip text-hs-text";
          return (
            <div key={i} style={{ width: `${width}%` }} className={cx("flex items-center justify-center truncate px-1 text-sm font-semibold", tone)} title={s.kind === "tier" ? tierText({ minGap: s.from, maxGap: s.to, blockMinutes: s.blockMinutes! }) : s.kind === "gap" ? "not covered" : "no BTB block"}>
              {s.kind === "tier" ? formatMinutes(s.blockMinutes!) : s.kind === "gap" ? "Gap" : "No block"}
            </div>
          );
        })}
      </div>
      <div className="mt-2 flex justify-between text-sm font-medium text-hs-text-muted"><span>0</span><span>1 hour</span><span>2 hours</span><span>3 hours</span><span>4+ hours open</span></div>
    </div>
  );
}
